import type { IModuleDefinition } from '@platform/core/types';
import type { IVizSource } from './IVizSource';

/**
 * Дочірня таблиця модуля для діаграми запису типу `rtKey`: тип із полем `field` (напр. «Категорія причини», «SWOT-категорія») і
 * полем-посиланням на цей тип; немає — null. Чиста функція.
 */
export function vizSourceOf(module: Pick<IModuleDefinition, 'recordTypes'>, rtKey: string, field: string): IVizSource | null {
  for (const rt of module.recordTypes) {
    if (rt.key === rtKey || !rt.fields.some((f) => f.key === field)) continue;
    const ref = rt.fields.find((f) => (f.type === 'ref' || f.type === 'lookup') && f.ref === rtKey);
    if (ref) return { rt, ref: ref.key };
  }
  return null;
}
